<template>
  <div>
    <div class="d-flex flex-column">
      <label>{{ trans('subscription.classification_config.group_modal.groupname') }}</label>
      <input
        v-model="name"
        class="form-control"
      >
      <label>{{ trans('subscription.classification_config.group_modal.max_amount_of_students') }}</label>
      <input
        v-model="max"
        class="form-control"
        type="number"
        min="1"
      >
      <GroupConfigTermSelect
        :term="term"
        @input="setTerm"
      />
      <div class="d-flex flex-row-reverse">
        <button
          type="button"
          class="btn btn-primary"
          @click="save()"
        >
          {{ trans('core.save') }}
        </button>
        <button
          v-if="selectedGroup"
          type="button"
          class="btn btn-warning me-1"
          :disabled="isLoading"
          @click="copy()"
        >
          <span class="fa fa-files-o" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast'
import GroupConfigTermSelect from '@/employees/components/GroupConfig/GroupConfigTermSelect'
import { mapState } from 'vuex'
export default {
  name: 'GroupEditView',
  components: {
    GroupConfigTermSelect,
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    selectedGroup: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      name: '',
      max: 1,
      term: null,
    }
  },
  computed: {
    ...mapState({
      groups (state) {
        let groups = Object.values(state.selectors.groups)
        groups = groups.concat(Object.values(state.groups.groups))
        if (this.selectedGroup) {
          if (this.selectedGroup.term) {
            return groups.filter(group => !(this.selectedGroup.name === group.name && group.term === this.selectedGroup.term))
          } else {
            return groups.filter(group => !(this.selectedGroup.name === group.name && group.term === undefined))
          }
        }
        return groups
      },
    }),
  },
  mounted () {
    if (this.selectedGroup) {
      this.name = this.selectedGroup.name
      this.max = parseInt(this.selectedGroup.max)
      this.term = this.selectedGroup?.term
    } else {
      this.name = ''
      this.max = 1
      this.term = null
    }
  },
  methods: {
    save () {
      if (!this.duplicateName()) {
        this.titleName = this.name
        if (this.selectedGroup) {
          this.$store.dispatch('delete_group', { name: this.selectedGroup.name, term: this.selectedGroup.term })
        }
        this.$store.dispatch('set_group', {
          name: this.name,
          max: parseInt(this.max),
          term: this.term,
        })
        this.$emit('Save', {
          name: this.name,
          max: parseInt(this.max),
          term: this.term,
        })
        if (this.selectedGroup) {
          this.$root.$emit('ConfigGroupUpdate',
            {
              oldName: this.selectedGroup.name,
              newName: this.name,
            },
          )
        }
      } else {
        toast.error(Lang.trans('subscription.classification_config.group_modal.unique_group_name'))
      }
    },
    duplicateName () {
      if (this.term) {
        return !!this.groups.find(group => group.name.toLowerCase() === this.name.toLowerCase() && group.term === this.term)
      } else {
        return !!this.groups.find(group => group.name.toLowerCase() === this.name.toLowerCase() && group.term === undefined)
      }
    },
    copy () {
      this.$emit('Copy')
    },
    setTerm (term) {
      this.term = term
    },
  },
}
</script>
